import * as Sentry from '@sentry/gatsby';
import { routes } from 'constants/routes';
import { navigate } from 'gatsby';
import { ThemeProvider } from 'providers/ThemeProvider';
import React, { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Helmet } from 'react-helmet';
import { GlobalStyles } from 'twin.macro';
import { LOG } from 'utils/helper';

import json from './package.json';

LOG('process.env.GATSBY_ENVIRONMET', process.env.GATSBY_ENVIRONMET);
LOG('process.env.NODE_ENV', process.env.NODE_ENV);


// Sentry.init({
// 	dsn: process.env.GATSBY_SENTRY_DSN,
// 	environment: process.env.GATSBY_ENVIRONMET,
// 	tunnel: `${process.env.GATSBY_BACKEND_URL}/monitoring-tunnel/`,
// 	enabled: true,
// 	// enabled: ['production'].indexOf(process.env.NODE_ENV) !== -1,
// 	integrations: [
// 		Sentry.browserTracingIntegration(),
// 		Sentry.replayIntegration(),
// 		Sentry.captureConsoleIntegration(),
// 	],
// 	// Set tracesSampleRate to 1.0 to capture 100%
// 	// of transactions for tracing.
// 	// We recommend adjusting this value in production
// 	tracesSampleRate: 1.0,
// 	// Capture Replay for 10% of all sessions,
// 	// plus for 100% of sessions with an error
// 	replaysSessionSampleRate: 0.1,
// 	replaysOnErrorSampleRate: 1.0,
// 	//release: 'npm@6.14.14',
// 	browserTracingOptions: {
// 		// disable creating spans for XHR requests
// 		traceXHR: false,
// 	}
// });

function ErrorFallback({ error, resetErrorBoundary }) {
	useEffect(() => {
		if(error) {
			Sentry.captureException(error);
		}
	}, [error]);

	const navigateToApplication = () => {
		navigate(routes.DASHBOARD);
		resetErrorBoundary();
	};

	return (
		<div className='flex flex-col items-center justify-center m-20'>
			<p>Coś poszło nie tak.</p>
			<button tw='bg-blue-1 text-09 text-light rounded-10 px-05 my-05' onClick={resetErrorBoundary}>Spróbuj ponownie</button>
			<button tw='bg-green-1 text-09 text-light rounded-10 px-05' onClick={navigateToApplication}>Wróć do aplikacji</button>
		</div>
	);
}

export default function ProvidersWrapper({ children }) {
	return (
		<ErrorBoundary FallbackComponent={ErrorFallback}>
			<ThemeProvider>
				<Helmet>
					<html lang="pl-PL" />
					<meta charSet="utf-8" />
					<meta name="version" content={json.version} />
					<title>Finteq</title>
				</Helmet>

				<GlobalStyles />

				{children}
			</ThemeProvider>
		</ErrorBoundary>
	);
}
